import { render } from "./DetailUser.vue?vue&type=template&id=55bf7e7e"
import script from "./DetailUser.vue?vue&type=script&lang=js"
export * from "./DetailUser.vue?vue&type=script&lang=js"
script.render = render

export default script